import { ProductType } from '@/organisations/models/product.model';
import { getLocalizedProducts } from '@/organisations/models/localized-product.model';
import { environment } from '@env';

export class History {
    id: number = -1;
    sfCompanyId = -1;
    sfFirmId = -1;
    sfCompanyName = '';
    productType = ProductType.PersonalTax; // Default to 'PERSONAL_TAX'
    createdAt = new Date(); // Default to current date
    statusCode = -1;
    userEmail = '';
    properties = {};
    silverfinUrl = '';
    localizedProductType = '';

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.sfCompanyId = data.sf_company_id ?? -1;
        this.sfFirmId = data.sf_firm_id ?? -1;
        this.sfCompanyName = data.sf_company_name ?? null;
        this.productType = data.product_type ?? ProductType.PersonalTax;
        this.createdAt = data.created_at ? new Date(data.created_at) : new Date();
        this.statusCode = data.status_code ?? null;
        this.userEmail = data.user_email ?? null;
        this.properties = data.properties ?? null;
        this.silverfinUrl = environment.silverfinCompanyLink(this.sfFirmId, this.sfCompanyId);
        this.localizedProductType = getLocalizedProducts()[this.productType];
        return this;
    }
}
